import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { FilterEventsIdPipeModule } from "src/app/pipes/filter-events-id/filter-events-id-pipe.module";

import { CollapsibleImageCardComponent } from "./collapsible-image-card.component";

@NgModule({
  declarations: [CollapsibleImageCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    FilterEventsIdPipeModule
  ],
  exports: [CollapsibleImageCardComponent],
})
export class CollapsibleImageCardComponentModule {}
